/* eslint-disable import/prefer-default-export */
import { push } from 'connected-react-router';
import { call, put, select, takeEvery, all } from 'redux-saga/effects';
import {
  SELECT_PROFILE,
  UPDATE_PROFILE,
  CANCEL_EDIT_PROFILE,
  GET_PROFILE,
} from '../constants/action-types/profile';
import { updateProfileSuccess, profileErrors, getProfileSuccess } from '../actions/profile';
import { makeSelectIdTkn } from '../selectors/auth';
import clientApi from '../utils/clientApi';

export function* updateProfile(action) {
  try {
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    const res = yield call(clientApi.put, `/profile/${action.id}`, action.data, options);
    res.data.sub = action.id;
    yield put(updateProfileSuccess(res.data));
  } catch (error) {
    yield put(profileErrors());
    yield put(push('/profile'));
  }
}

export function* getProfile(action) {
  try {
    const idToken = yield select(makeSelectIdTkn());
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`,
      },
    };
    const res = yield call(clientApi.get, `/profile/${action.id}`, options);
    yield put(getProfileSuccess(res.data));
  } catch (error) {
    yield put(profileErrors());
    yield put(push('/profile'));
  }
}

function* watchGetProfile() {
  yield takeEvery(GET_PROFILE, getProfile);
}

function* redirectToProfile() {
  yield put(push(`/profile`));
}

function* watchRedirectSelectedProfile() {
  yield takeEvery(SELECT_PROFILE, redirectToProfile);
}

function* watchRedirectUpdateProfile() {
  yield takeEvery(UPDATE_PROFILE, updateProfile);
}

function* watchRedirectCancelUpdateProfile() {
  yield takeEvery(CANCEL_EDIT_PROFILE, redirectToProfile);
}

export default function* profileSaga() {
  yield all([
    watchGetProfile(),
    watchRedirectSelectedProfile(),
    watchRedirectUpdateProfile(),
    watchRedirectCancelUpdateProfile(),
  ]);
}
